// auth/authService.js
// Auth centralisée (UI-agnostic). Ne dépend pas du DOM.

import { getSupabaseClient } from "../infra/supabaseClient.js";

function isValidEmail(email){
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email||"").trim());
}

export async function getCurrentUser(){
  const client = getSupabaseClient();
  const { data, error } = await client.auth.getUser();
  if(error) throw error;
  return data?.user || null;
}

export async function logout(){
  const client = getSupabaseClient();
  const { error } = await client.auth.signOut();
  if(error) throw error;
}

export async function login(email, password, { createIfMissing = true } = {}){
  const client = getSupabaseClient();
  const e = String(email||"").trim();
  const p = String(password||"");
  if(!e || !p) throw new Error("Email + mot de passe requis");
  if(!isValidEmail(e)) throw new Error("Email invalide");

  // If a user is already logged in:
  // - if same email => reuse session
  // - if different email => sign out before trying new credentials
  try{
    const { data } = await client.auth.getUser();
    const currentEmail = (data?.user?.email || "").toLowerCase();
    if(data?.user){
      if(currentEmail === e.toLowerCase()){
        return { user: data.user, reusedSession: true };
      }
      await client.auth.signOut();
    }
  }catch(_e){
    // ignore and try fresh login
  }

  // Try sign-in
  let res = await client.auth.signInWithPassword({ email: e, password: p });
  if(!res.error) return { user: res.data?.user || null, reusedSession: false };

  if(!createIfMissing){
    throw res.error;
  }

  // Playtest-friendly: if sign-in fails, try sign-up then sign-in again
  const up = await client.auth.signUp({ email: e, password: p });
  if(!up.error){
    res = await client.auth.signInWithPassword({ email: e, password: p });
    if(!res.error) return { user: res.data?.user || null, reusedSession: false };
  }

  throw res.error || up.error || new Error("Auth error");
}

export function onAuthStateChange(cb){
  const client = getSupabaseClient();
  return client.auth.onAuthStateChange((event, session) => {
    try{ cb?.(event, session); }catch(_e){}
  });
}
